<template>
    <div class="py-5">
        <Title/>
        <b-card style="max-width: 600px" class="mx-auto text-left px-3 py-3">
            <h5 class="pb-3">Register</h5>
            <b-form-group 	label="Email"
                            :state="errors.has('email')? false : null"
                            :invalid-feedback="errors.first('email')"
            >
                <b-form-input 	name="email"
                                v-model="user.email" 
                                v-validate="'required|email'"
                                :state="errors.has('email')? false : null"
                />
            </b-form-group>

            <b-form-group 	label="First Name"
                            :state="errors.has('firstName')? false : null"
                            :invalid-feedback="errors.first('firstName')"
            >
                <b-form-input   name="firstName"
                                v-model="user.firstName" 
                                v-validate="'required'"
                                :state="errors.has('firstName')? false : null"
                />
            </b-form-group>

            <b-form-group 	label="Last Name"
                            :state="errors.has('lastName')? false : null"
                            :invalid-feedback="errors.first('lastName')"
            >
                <b-form-input 	name="lastName"
                                v-model="user.lastName" 
                                v-validate="'required'"
                                :state="errors.has('lastName')? false : null"
                />
            </b-form-group>

            <b-form-group 	label="Username" description="Will be shown in calls instead of first & last name">
                <b-form-input 	v-model="user.username" />
            </b-form-group>

            <b-form-group 	label="Job">
                <b-form-input 	v-model="user.job" />
            </b-form-group>

            <b-form-group 	label="Department">
                <b-form-input 	v-model="user.department" />
            </b-form-group>

            <b-form-group 	label="Phone Number">
                <b-form-input 	v-model="user.phone" />
            </b-form-group>

            <div class="text-right">
                <b-btn variant="primary" class="mr-2" @click="update">Update</b-btn>
                <b-btn :to="{ name: 'Dashboard' }">Cancel</b-btn>
            </div>
        </b-card>
    </div>
</template>

<script>
import Title from '@/components/Title'
export default {
    data() {
        return {
            user: {
                email: '',
                firstName: '',
                lastName: '',
                username: '',
                job: '',
                department: '',
                phone: ''
            }
        }
    },
components: {Title},
    async mounted() {
        this.user = await this.$app.service('users').get('$userId');
        // this.$app.authenticate()
            // .then(() => this.$router.push({ name: 'Profile' }))
    },

    methods: {
		async update() {
			if (!await this.$validator.validate()) {
				return;
			}

			this.$app.service('users').patch(this.user._id, this.user)
				.then(this.$router.push({ name: 'Dashboard' }))
				.catch(error => alert(error));
		},
	}
}
</script>
